import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies.password-authentication-policy.edit-policy', {
        url: '/edit-policy/:policyId',
        views: {
            '@company.policies': 'passwordAuthenticationPoliciesViewEdit',
        },
        resolve: {policy},
    });
}

/** @ngInject */
function policy($stateParams,companyId,PasswordAuthenticationPoliciesService) {
    return PasswordAuthenticationPoliciesService.getPasswordPolicyDetails(companyId,$stateParams.policyId)
}


// WEBPACK FOOTER //
// ./src/portal/states/company/policies/password-authentication-policy/edit-policy/edit-policy.state.js